/// <amd-module name="Build/Pipelines/Tabs/Branches/BranchesView" />
import { Performance } from "Build/Pipelines/Performance";
import * as Resources from "Build/Pipelines/Resources";
import { BranchesViewItem, IBranchesDataService } from "Build/Pipelines/Tabs/Branches/BranchesDataService";
import { BranchesTable } from "Build/Pipelines/Tabs/Branches/BranchesTable";
import { ISourceProviderService } from "Build/SourceProviders/SourceProvider";
import * as React from "react";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { Dropdown } from "VSSUI/Dropdown";
import { IListBoxItem } from "VSSUI/ListBox";
import { DropdownSelection } from "VSSUI/Utilities/DropdownSelection";

export interface Props extends IVssComponentProperties {
    isPageLoad: boolean;
    definitionId: number;
}

export interface State {
    branches: BranchesViewItem[];
    repositoryItems: IListBoxItem[];
}

export class BranchesView extends VssComponent<Props, State> {
    private dataService: IBranchesDataService;
    private selection = new DropdownSelection();
    private ttiMarked = false;

    constructor(props: Props, context: IVssComponentContext) {
        super(props, context);

        this.state = {
            branches: [],
            repositoryItems: []
        };

        const sourceProviderService = this.context.pageContext.getService<ISourceProviderService>("ISourceProviderService");

        this.dataService = this.context.pageContext.getService<IBranchesDataService>("IBranchesDataService");
        this.dataService.data.subscribe(branches => {
            const repositories: { [id: string]: IListBoxItem } = {};

            // Preserve known repositories, because a new filter may not include all the repositories
            for (const repo of this.state.repositoryItems) {
                repositories[repo.id] = repo;
            }

            for (const branch of branches) {
                for (const build of branch.builds) {
                    for (const repo of build.usedRepositoryBranches) {
                        if (!repositories[repo.repositoryId]) {
                            const sourceProvider = sourceProviderService.getSourceProvider(repo.repository.type);
                            const iconName = sourceProvider ? sourceProvider.getRepoIconName() : "";

                            repositories[repo.repositoryId] = {
                                id: repo.repositoryId.toFixed(),
                                iconProps: {
                                    iconName,
                                    className: "repo-filter-logo repo-filter-" + iconName
                                },
                                text: repo.repository.name
                            };
                        }
                    }
                }
            }

            this.setState({
                branches,
                repositoryItems: Object.keys(repositories).map(key => repositories[key])
            });
        });

        this.selection.select(0);

        this.dataService.fetchData(this.props.definitionId, 0, !this.props.isPageLoad);
    }

    public render() {
        const { branches, repositoryItems } = this.state;
        return (
            <div className="flex-column rhythm-vertical-8">
                {repositoryItems.length > 1 && (
                    <div className="flex-row flex-center rhythm-horizontal-8 margin-horizontal-20 margin-bottom-8">
                        <label>{Resources.GroupByRepository}</label>
                        <Dropdown
                            className="group-by-repository-dropdown"
                            items={repositoryItems}
                            selection={this.selection}
                            onSelect={this.onSelectRepository}
                        />
                    </div>
                )}
                <BranchesTable branches={branches} definitionId={this.props.definitionId} />
            </div>
        );
    }

    public componentDidUpdate() {
        if (!this.ttiMarked && this.state.branches.length > 0) {
            this.ttiMarked = true;
            new Performance(this.context.pageContext).mark("branches");
        }
    }

    private onSelectRepository = (event: React.SyntheticEvent<HTMLElement, Event>, item: IListBoxItem<{}>) => {
        this.dataService.fetchData(this.props.definitionId, Number(item.id), true);
    };
}
